(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var lines = document.getElementById('cartLines');
    if (!lines) return;

    lines.addEventListener('click', function (e) {
      var incBtn = e.target.closest('[data-qty-increase]');
      var decBtn = e.target.closest('[data-qty-decrease]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (incBtn) changeLine(incBtn.dataset.qtyIncrease, 1);
      if (decBtn) changeLine(decBtn.dataset.qtyDecrease, -1);
      if (removeBtn) setLine(removeBtn.dataset.cartRemove, 0);
    });

    function changeLine(key, delta) {
      var valueEl = document.querySelector('[data-qty-value="' + key + '"]');
      var current = parseInt(valueEl.textContent, 10) || 1;
      var next = Math.max(0, current + delta);
      setLine(key, next);
    }

    function setLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart, key, quantity); })
        .catch(function (err) { console.error('[evelina] cart update failed', err); });
    }

    function render(cart, changedKey, newQuantity) {
      if (newQuantity === 0) {
        var row = document.querySelector('[data-cart-line-key="' + changedKey + '"]');
        if (row) row.remove();
      } else {
        var valueEl = document.querySelector('[data-qty-value="' + changedKey + '"]');
        if (valueEl) valueEl.textContent = newQuantity;
        var item = cart.items.find(function (i) { return i.key === changedKey; });
        var priceEl = document.querySelector('[data-cart-line-price="' + changedKey + '"]');
        if (item && priceEl) priceEl.textContent = formatMoney(item.final_line_price, cart.currency);
      }

      var subtotalEl = document.getElementById('cartSubtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);

      var countEl = document.getElementById('count');
      if (countEl) countEl.textContent = cart.item_count;

      var pageCount = document.querySelector('.cart-page-count');
      if (pageCount) pageCount.textContent = cart.item_count;

      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency || 'USD',
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }
  });
})();
